import { END_POINT } from "@constants/api.constants";
import { PRIMARY_KEY } from "@constants/app.constants";
import { formatStatus } from "@utils/string.utils";

const keyColumn = PRIMARY_KEY;
const { USER_STATUS_TOGGLE } = END_POINT;
const tableTitle = "Users List";
const menuUrl = "user-administration/users";
const tableColumn = [
  {
    id: "role",
    numeric: false,
    disablePadding: true,
    label: " Role",
  },
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: " Name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: true,
    label: " Email",
  },
  {
    id: "username",
    numeric: false,
    disablePadding: true,
    label: "Username",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
    isBadge: true,
    badgeClick: USER_STATUS_TOGGLE,
    primaryKey: keyColumn,
    formatData: formatStatus,
    badgeText: {
      1: "Enabled",
      2: "Disabled",
    },
    badgeColor: {
      1: "success",
      2: "danger",
    },
  },
  {
    id: "created_at",
    numeric: false,
    disablePadding: true,
    label: "Created At",
  },
];
const breadCrumbs = [
  { name: "User Administration", menu_url: null },
  { name: "Users", menu_url: "/user-administration/users" },
];

const filters = ({ roles }) => [
  {
    name: "role",
    id: "role_name",
    label: "Role Name",
    value: "",
    isMultiple: true,
    options: roles,
    type: "AUTOCOMPLETE",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
  {
    name: "email",
    id: "email",
    label: "Email",
    value: "",
    type: "TEXT",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
  {
    name: "name",
    id: "username",
    label: "Username",
    value: "",
    type: "TEXT",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
];

export { tableTitle, keyColumn, tableColumn, breadCrumbs, menuUrl, filters };
